// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c2c5d34463ab49cf8646","655":"01de745b7d2272fd1f23"}[chunkId] + ".js";
};